/**
 * Employee profile photos are stored on the HRMS API (e.g. /uploads/profiles/...).
 * The onboarding SPA runs on a different origin, so relative paths must be absolutized.
 */
const stripTrailingSlash = (s: string) => s.replace(/\/$/, '');

function hrmsApiBase(): string {
  const fromEnv =
    (import.meta.env.VITE_HRMS_API_BASE_URL as string | undefined) ||
    (import.meta.env.VITE_HRMS_API_URL as string | undefined);
  if (fromEnv && String(fromEnv).trim()) {
    return stripTrailingSlash(String(fromEnv).trim());
  }
  // Local dev: HRMS backend serves /uploads (see hrms/backend/server.js)
  if (import.meta.env.DEV) {
    return 'http://localhost:5000';
  }
  // Production fallback — set VITE_HRMS_API_BASE_URL for other hosts
  return 'https://api.hrms.aerinit.com';
}

export function resolveProfilePictureUrl(pathOrUrl: string | null | undefined): string {
  if (pathOrUrl == null) return '';
  const s = String(pathOrUrl).trim();
  if (!s) return '';
  if (s.startsWith('http://') || s.startsWith('https://') || s.startsWith('data:')) {
    return s;
  }
  const base = hrmsApiBase();
  const path = s.startsWith('/') ? s : `/${s}`;
  return `${base}${path}`;
}
